const VUE_APP_API_ZKPCURL_URL = document.querySelector("body").getAttribute("api_zkpcurl_url");

export default VUE_APP_API_ZKPCURL_URL
